import { subscribeChannel, publishChannel } from './channelUtils';

export function sendLines(linhas) {
    
    publishChannel('linhas-sync', linhas);

}

export function sendLineUpsert(linha) {
    
    publishChannel('linha-upsert', linha);

}

export function sendLineRemove(codigo) {
    
    publishChannel('linha-remove', codigo);

}

export function sendLinesFilters(filters) {

    publishChannel('lines:filters', filters);

}

// =========================
// METROS TOTAL ROTA
// =========================

export function sendMetrosTotalRota(metrosTotalRota) {

    publishChannel('metros-total-rota-sync', metrosTotalRota);

}

export function sendMetrosTotalRotaUpdated({
    codigo,
    metrosTotalRota
}) {

    publishChannel(
        'metros-total-rota-updated',
        {
            codigo,
            metrosTotalRota
        }
    );

}

export function sendMetrosTotalRotaDeleted(codigo) {

    publishChannel('metros-total-rota-delete', codigo);

}


export function listenLines(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'linhas-sync' &&
            tipo !== 'linha-upsert' &&
            tipo !== 'linha-remove' &&
            tipo !== 'lines:filters' &&
            tipo !== 'metros-total-rota-sync' &&
            tipo !== 'metros-total-rota-updated' &&
            tipo !== 'metros-total-rota-delete'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}